// In LikedUsersPopupComponent
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
@Component({
  selector: 'app-liked-users-popup',
  templateUrl: './liked-users-popup.component.html',
  styleUrls: ['./liked-users-popup.component.scss'],
})
export class LikedUsersPopupComponent implements OnInit {
  likedUsersData: any[] = [];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<LikedUsersPopupComponent>) { }
  ngOnInit(): void {
    if (this.data) {
      this.likedUsersData = this.data;
    }
  }
  closeDialog() {
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown");
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp");
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }
}